<template>
    <div id="workWithUs">
        <emojis/>
        <div class="modal fade" id="modalStatusSend" tabindex="-1" role="dialog" aria-labelledby="StatusSendModalLabel" aria-hidden="true">
            <div class="modal" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{status}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{content}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row first-camp">
                    <div class="col-md-3 flex j-c-center text-center">
                        <div>
                            <h1 class="color-white big-title f-w-700">Trabalhe <br> Conosco</h1>
                        </div>    
                    </div>
                    <div class="col-md-9 col-12 in-992 flex j-c-center">
                        <p class="toDescriptions color-white">
                            Muito mais do que tecnologia, a gente acredita que pessoas são chave para que a gente chegue lá. <br>
                            Por isso, estamos sempre em busca dos melhores talentos para o nosso time. <br>
                            Gente jovem de espírito (independente da idade) e que se identifique com os nossos valores! <br>
                            Para trabalhar com a gente você precisa: Ter foco em resultados, Ser flexível, Saber se comunicar bem, Querer desafiar o status quo, Ter muita coragem e garra.
                        </p>
                    </div>
                </div>
            <form @submit.prevent="onSubmit" class="relative">
                <div class="sendigSvg" v-show="svgSending">
                    <img class="img-responsive" src="@/lib/SVG-Loaders-master/ball-triangle.svg" alt="ball-triangle">
                </div>
                <div class="collapsers row">
                   <div class="col-md-6">
                       <h3 class="f-w-700 color-white">Vagas</h3>
                       <div class="colCursor" v-for="(item, index) in Job_Vacancy" :key="index">
                            <div class="flex sp-between target" @click="LetsToggle('#LetsToggle_'+index,'#chevronState_'+index)">
                                <div class="flex c-center">
                                    <h2>{{item.office}}</h2>
                                </div>
                                <div>
                                    <div :id="'chevronState_'+index">
                                        <img class="img-responsive" src="@/assets/home/chevronDown.png" alt="chevronDown">
                                    </div>
                                </div>                        
                            </div>
                            <div class="toToggle" :id="'LetsToggle_'+index">
                                <div class="content">
                                    <p>
                                        {{item.acting}}
                                    </p>
                                </div>
                                <div class="requirements">
                                    <p>{{item.requirements}}</p>
                                </div>
                                <div class="anchoring">
                                    <button @click="SendiValueVacancy(item.office)" class="BigAnchor selectinfVacancy bg-color-F38235 color-white f-w-700">Selecionar vaga</button>
                                </div>
                            </div>
                        </div> 
                    </div>
                    <div class="col-md-6">
                       <h3 class="f-w-700 color-white">{{VacancySelected}}</h3>
                       <div class="row">
                           <div class="col-lg-6 col-md-12">
                               <input required type="text" placeholder="Nome" v-model="form.FromName">
                               <input required type="email" placeholder="E-mail" v-model="form.From">
                            </div>
                       </div>
                       <div class="radiosCamp" v-for="(item, index) in ExperiencesWithBusiness" :key="index">
                           <label>{{item.label+'?'}}</label>
                            <div class="flex">
                                <div>
                                    <input required @click="arrXp('haveXp'+index, item.label)" type="radio" :name="'name_'+index" :value="item.label" :id="'radioYes_'+index">
                                </div>
                                <div>
                                    <label>Sim</label>
                                </div>
                                <div>
                                    <input required @click="arrXp('haveXp'+index,'Não '+item.label)" type="radio" :name="'name_'+index" :value="'Não '+item.label" :id="'radioNo_'+index">
                                </div>
                                <div>
                                    <label>Não</label>
                                </div>
                            </div>                            
                        </div>  
                        <div class="shareCurriculum">
                            <div>
                                <label for="ShareCurriculum">Anexe o seu currículo</label>
                            </div>
                            <div>
                                <label for="ShareCurriculum" class="sharing bg-color-FFF color-blue">Anexar currículo</label>
                            </div>
                            <input required type="file" name="" id="ShareCurriculum" hidden @change="inputFile">                            
                            <div>
                                <small class="fileName color-white">{{fileName}}</small>
                            </div>

                            <div id="Send">
                                <button type="submit" class="color-white" id="Btn-send" :disabled="isBtnDisabled">{{StatusSendding}}</button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    </div>
</template>

<style scoped>
*{
    transition-duration: 0;
    transition-timing-function: ease-in;
}    
h2{
    line-height: 1.25!important
}     
    .selectinfVacancy{
        padding: 8px 25px;
        border-radius: 10px;
        font-size: 12px;
    }

    input[type="text"], input[type="email"] {
        background-color: #fff;
        width: 100%;
        height: 50px;
        margin: 0 0 15px 0;
        padding-left: 15px;
        text-align: left;
        border-radius: 10px;
    }

    input::placeholder{
        text-align: left;
    }

    .fileName{
        font-size: 10px;
    }

    .sharing{
        padding:8px 40px;
        border-radius: 10px;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, .15);
        color: #175D93;
        font-size: 14px;
        margin: 5px 0;
    }


    .sharing:hover{
        background-color: rgba(23, 93, 147,75);
        color: rgba(255, 255, 255, .8);
        cursor: pointer;
    }

    #Send > button:hover{
        background-color: rgba(3, 73, 127);
    }
    

    .colCursor .target{
        padding: 15px 20px;        
    }

    .colCursor{
        background-color: #fff;
        margin: 15px 0;
        border-radius: 10px;
    }

    .colCursor h2{
        font-size: 14px;
        margin: 0;
        color: rgb(173, 173, 173);
    }

    .colCursor :hover{
        cursor: pointer;
    }

    .rotate{
        transform: rotateZ(180deg)
    }

    

    #workWithUs{
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#e0a638+1,f38235+100 */
        background: #e0a638; /* Old browsers */
        background: -moz-linear-gradient(45deg,  #e0a638 1%, #f38235 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(45deg,  #e0a638 1%,#f38235 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(45deg,  #e0a638 1%,#f38235 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0a638', endColorstr='#f38235',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
        padding-top: 100px;
    }

    h1{
        margin-bottom: 30px;
    }

    h3{
        font-size: 20px;
        padding: 15px 0;
    }

    .colCursor p{
        max-width: 100%;
        font-size: 12px;
        color: rgb(173, 173, 173);
        padding: 15px 20px 5px 20px;
        margin: 0
    }

    .anchoring{
        margin-top: 10px;
        padding: 10px 0 30px 20px;
    }

     label{
        font-size: 12px;
        top: -25px!important;
        color: #fff;
        font-weight: 700;
    }
    
    .first-camp{
        border-top: 2px solid rgba(255, 255, 255, 0.4);
        border-bottom: 2px solid rgba(255, 255, 255, 0.4);
        margin-bottom: 50px;
        padding: 20px 0;
    }

    .radiosCamp label{
        font-weight: normal;
        font-size: 14px;
        margin: 0 25px 0 5px
    }

    #Send > button{
        background-color: rgb(23, 93, 147);
        padding: 15px 50px;
        font-size: 14px;
        border-radius: 30px;
        margin-top: 25px;
    }

    .radiosCamp{
        margin-bottom: 30px;
    }

    .radiosCamp > div{
        margin-top: 25px;
    }
    

    input[type=radio] {
        width: 25px;
        height: 25px;
    }

    p.toDescriptions{
        font-size: 16px;
    }

    @media only screen and (max-width: 992px){
        .in-992{
            text-align: center;
        }

        #img_1 img{
            width: 100%;
        }
    }

    @media only screen and (max-width: 767px){
        p.toDescriptions{
            margin-right: 0px;
            text-align: center
        }
    }

</style>

<script>
import Emojis from '@/components/EmojisWorkWithUs.vue';
import $ from 'jquery';

export default {
    data() {
        return {
            fileName:"(Nenhum arquivo)",
            VacancySelected:"Selecione uma vaga",
            StatusSendding:"Enviar",
            svgSending: false,
            status:"",
            content:"",
            fileBytes: "",
            haveXp0:[],
            haveXp1:[],
            isBtnDisabled: false,
            form: {
                LogoUrl: "http://www.fasters.com.br/res/images/clientes/pontofacil.png",
                MailTo: "contato@pontofacil.com.br",
            },
            ExperiencesWithBusiness:[
                {
                    label: "Possui experiência de trabalho em Franquias",
                    vmodel: this.haveXp0,
                },
                {
                    label: "Possui experiência de trabalho em Franqueadoras",
                    vmodel: this.haveXp1,
                }
            ],
            Job_Vacancy:[
                {
                    office:"Auxiliar Administrativo",
                    acting:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
                    requirements:"Ensino Superior completo"
                },
                {
                    office:"Analista de Redes Sociais",
                    acting:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
                    requirements:"Ensino Superior completo"
                },
                {
                    office:"Gerente de Produtos",
                    acting:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
                    requirements:"Ensino Superior completo"
                },
                {
                    office:"Supervisor de Franquias",
                    acting:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
                    requirements:"Ensino Superior completo"
                },
                {
                    office:"Web Designer",
                    acting:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
                    requirements:"Ensino Superior completo"
                },
                {
                    office:"Front End Web Developer",
                    acting:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
                    requirements:"Ensino Superior completo + Pós graduação"
                },
            ],
        }
    },
    mounted() {
        this.$ga.page('/vagas');
        $( ".BigAnchor" ).click(function( event ) {
            event.preventDefault();
        });
    },
    components:{
        Emojis
    },
    methods: {
        
        arrXp(arr, value){
            switch (arr) {
                case 'haveXp0':
                    this.haveXp0=[];
                    this.haveXp0.push(value)
                    console.log(this.haveXp0)// eslint-disable-line no-console
                break;
                case 'haveXp1':
                    this.haveXp1=[];
                    this.haveXp1.push(value)
                    console.log(this.haveXp1)// eslint-disable-line no-console
                break;
            
                default:
                    break;
            }
        },
        LetsToggle(LetsToggle, chevronState){
            $(LetsToggle).toggle( "fast", function(){
                $(chevronState).toggleClass('rotate');
            });
        },        
        inputFile: function(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.createFile(files[0]);
            },
            createFile(file) {
                var reader = new FileReader();
                var that = this;

                reader.onloadend = e => {
                that.fileBytes = e.target.result.split("base64,")[1];
            };

                that.fileName = file.name;
                console.log(that.fileName);// eslint-disable-line no-console
                reader.readAsDataURL(file);
            },
        
        SendiValueVacancy(value){
            this.VacancySelected = value
        },
        onSubmit() {
            if(this.VacancySelected == "Selecione uma vaga"){
                this.$alert("Você precisa selecionar uma vaga para se candidatar.");
            }else{
                this.svgSending = true;
                this.form.FileName = this.fileName;
                this.form.FileBytes = this.fileBytes;
                this.btnText = "Enviando...";
                this.isBtnDisabled = true;
                this.form.message =
                "<br> <strong> Vaga selecionada: " + this.VacancySelected + " </strong>"+
                "<br><strong>Experiências:</strong><br><strong>* " + this.haveXp0[0] + "</strong>"+
                "<br><strong>* " + this.haveXp1[0] + "</strong>";
                this.$http
                .post("https://mail.fasters.com.br/api/send", this.form, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: this.token
                }
                })
                .then(
                response => { //eslint-disable-line no-var, no-unused-vars
                    this.$alert("Seu currículo foi recebido com sucesso. Oportunamente entraremos em contato. Obrigado.");
                    this.btnText = "Enviar";
                    this.form = "";
                    this.fileName = '(Nenhum arquivo)'
                    this.$ga.event({
                    eventCategory: "formCur",
                    eventLabel: "enviado",
                    eventAction: "enviar"
                    });
                    (this.isBtnDisabled = false);
                    this.svgSending = false;
                },
                response => {
                    this.$alert("Algo de errado aconteceu. Nossa equipe já está verificando. Tente novamente mais tarde.");
                    this.isBtnDisabled = false;
                    this.btnText = "Enviar";
                    this.fileName = '(Nenhum arquivo)'
                    console.log(response);// eslint-disable-line no-console
                    this.svgSending = false;
                }
                );
            }
            
        },
    },  
    
}
</script>